import React, { useMemo } from 'react'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import config from 'constants/config'
import {
  formatCharterFareClassListForBanner,
  getOrderedCharterFareClasses,
} from 'lib/charterFlights/charterOfferFareClassRestrictions'
import { useMaldivesDirectBundleContext } from 'components/MaldivesDirect/MaldivesDirectSearchPage/MaldivesDirectBundleContext'
import { isWhitelabelBrand } from 'lib/whitelabels/whitelabels'

interface Props {
  offerId: string
}

function HotelSearchTileCharterFareClassBanner({ offerId }: Props) {
  const isLifestyleBrand = isWhitelabelBrand(config.BRAND)
  const {
    charterBundle,
    allowedFareClassesByOfferId,
    hasFareClassRestrictionsByOfferId,
  } = useMaldivesDirectBundleContext()

  const allowedFareClasses = useMemo(() => {
    return allowedFareClassesByOfferId.get(offerId)
  }, [allowedFareClassesByOfferId, offerId])
  const hasFareClassRestrictions = useMemo(() => {
    return hasFareClassRestrictionsByOfferId.get(offerId) ?? false
  }, [hasFareClassRestrictionsByOfferId, offerId])

  const orderedAllowedFareClasses = useMemo(() => {
    if (!allowedFareClasses || allowedFareClasses.length === 0) {
      return undefined
    }
    return getOrderedCharterFareClasses(allowedFareClasses)
  }, [allowedFareClasses])

  const bannerMessage = useMemo(() => {
    if (!orderedAllowedFareClasses || orderedAllowedFareClasses.length === 0) {
      return undefined
    }
    const formattedClasses = formatCharterFareClassListForBanner(orderedAllowedFareClasses)
    return `Available exclusively with ${formattedClasses} flights`
  }, [orderedAllowedFareClasses])

  if (isLifestyleBrand || !charterBundle || !hasFareClassRestrictions || !allowedFareClasses || !orderedAllowedFareClasses || !bannerMessage) {
    return null
  }

  return (
    <MessageBanner kind="promotional-primary">
      <b>{bannerMessage}</b>
    </MessageBanner>
  )
}

export default HotelSearchTileCharterFareClassBanner
